<div class="controls-container">
    <div class="controls-header">Layouts</div>

    <div class="layout-cards">
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                 <pm-layout-1></pm-layout-1>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-2></pm-layout-2>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-3></pm-layout-3>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-4></pm-layout-4>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-5></pm-layout-5>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-6></pm-layout-6>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-7></pm-layout-7>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-8></pm-layout-8>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-9></pm-layout-9>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-10></pm-layout-10>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-11></pm-layout-11>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-12></pm-layout-12>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-13></pm-layout-13>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-14></pm-layout-14>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="height: 100px; width: 200px;">
                <pm-layout-15></pm-layout-15>
            </div>
        </pm-card>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout.html